module.exports = __webpack_public_path__ + "img/x.67784648.svg";